import React from 'react';
import { WarningImg } from './styled';
import warning from 'assets/warning.png';

export function Warning({ large }: { large?: boolean }) {
  return <WarningImg large={large} alt="warning" src={warning} />;
}
